import { render } from "./DocumentChunkingPanel.vue?vue&type=template&id=435a29e5&scoped=true"
import script from "./DocumentChunkingPanel.vue?vue&type=script&lang=js"
export * from "./DocumentChunkingPanel.vue?vue&type=script&lang=js"

import "./DocumentChunkingPanel.vue?vue&type=style&index=0&id=435a29e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435a29e5"]])

export default __exports__